import { mergeOptions } from '../../helpers/common/merge-options';

export interface IFramePlayerOptions {
	startPlayerClassName: string;
	playingClassName: string;
}

export class IFramePlayer {
	private button: HTMLElement | null;
	private iframe: HTMLIFrameElement | null;
	private options: IFramePlayerOptions;

	static options: IFramePlayerOptions = {
		startPlayerClassName: 'js-player-start',
		playingClassName: 'is-playing',
	};

	constructor(private element: HTMLElement, options?: IFramePlayerOptions) {
		this.options = mergeOptions(IFramePlayer, options, element);

		this.button = element.querySelector(
			`.${this.options.startPlayerClassName}`
		);

		this.iframe = element.querySelector('iframe');

		if (this.button) {
			this.button.addEventListener('click', () => this.play(), {
				once: true,
			});
		}
	}

	play() {
		if (this.iframe) {
			if (this.iframe.src.indexOf('autoplay') != -1) {
				this.iframe.src = this.iframe.src.replace("autoplay=0", "autoplay=1");
			} else {
				this.iframe.src += this.iframe.src.indexOf('?') === -1 ? '?autoplay=1' : '&autoplay=1';
			}
			this.element.classList.add(this.options.playingClassName);
		}
	}

	destroy() {
		this.iframe?.setAttribute('src', '');
	}
}
